import { navigate } from 'gatsby'
import Api, { spoofMode, spoofedUserId } from '../api'

export function deleteDogById(dogId: string) {
  const url = spoofMode
    ? '/v1/private/admin/account/dog/' + dogId + '/?userId=' + spoofedUserId
    : '/v1/private/account/dog/' + dogId

  return new Promise<any>((resolve, reject) => {
    Api.del('wwwREST', url, {})

      .then(res => resolve(res))

      .catch(err => {
        if (err.response.status === 503) {
          navigate('/maintenance')
        }
        console.error('Error delete dog by Id')
        reject(err.message)
      })
  })
}
